<app-sidebar>
    <div class="main" *ngFor="let facility of this.evaluation?.facilities">
        <div class="buttonWithDescription" *ngIf="canSeeFacilityTokens(facility)">
            <span>Pdf with tokens for facility: {{facility.facility_name}}</span>
        <button id="download-tokens-pdf" mat-raised-button color="primary" (click)="generatePDF(facility)">Download</button>
        </div>
    </div>
</app-sidebar>

